module.exports = __webpack_public_path__ + "static/media/hourglass-end.8f839b1e.svg";